import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import { AppNameTm } from "constants/app-name-tm";
import { t } from "i18next";
import React from "react";

interface OfflineFeatureDisabledInfoProps {
    resource: string;
}

const CSS_BASE_CLASS = "c-offline-feature-disabled-info";
const OfflineFeatureDisabledInfo: React.FC<OfflineFeatureDisabledInfoProps> = ({
    resource,
}) => {
    return (
        <div className={`${CSS_BASE_CLASS}`}>
            <div className={`${CSS_BASE_CLASS}__info-wrapper`}>
                <Heading cssClassName={`${CSS_BASE_CLASS}__title`}>
                    {t("offline-dashboard-recent-items-disabled-title", {
                        resource: resource,
                    })}
                </Heading>
                <Paragraph cssClassName={`${CSS_BASE_CLASS}__description`}>
                    {t(
                        "offline-dashboard-recent-bookmarks-disabled-description",
                        {
                            appName: AppNameTm,
                        }
                    )}
                </Paragraph>
            </div>
        </div>
    );
};

export default OfflineFeatureDisabledInfo;
